import {
  findMenuProductByChainProductId,
  parseUpsellsSalsaUtensilsIds,
} from './upsells';

export function getUtensilsProductId(menu: any, remoteConfigData?: unknown) {
  if (remoteConfigData != null) {
    const parsed = parseUpsellsSalsaUtensilsIds(remoteConfigData);
    if (parsed?.utensils?.length) {
      for (const uid of parsed.utensils) {
        const found = findMenuProductByChainProductId(menu, uid);
        if (found?.id != null) {
          return found.id;
        }
      }
    }
  }

  if (!menu?.categories?.length) {
    return undefined;
  }

  for (const category of menu.categories) {
    const products = category?.products ?? [];
    for (const product of products) {
      const metadata = product?.metadata ?? [];
      const isUtensils = metadata.some(
        (item: any) =>
          item?.key === 'isUtensils' &&
          (item?.value === true || item?.value === 'true'),
      );
      if (isUtensils) {
        return product.id;
      }
    }
  }

  return undefined;
}
